module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a9ea140","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Bgcanvas.vue
// module id = 1262
// module chunks = 2